import { CommonModule } from '@angular/common';
import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxComponentDef } from '@df/ui/form/checkbox/checkbox.component.def';

@Component({
    selector: 'toggle',
    templateUrl: 'toggle.html',
    styleUrl: './toggle.scss',
    standalone: true,
    imports: [CommonModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleComponent),
            multi: true
        }
    ]
})
export class ToggleComponent extends CheckboxComponentDef {}
